var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotInPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1494.498,
    height: 1172.421,
    viewBox: "0 0 1494.498 1172.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email_update",
    "data-name": "Email update",
    transform: "translate(-223.719 -1806.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(-4530.33 -1494.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(-2077.952 3178.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(6769.949 45.96)",
    fill: "#c2b59c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "a607546c832ea069bbec792023522cad",
    transform: "translate(7156.095 392.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M368.6,113.609V2.5H35.277C18.611,2.5,7.5,13.611,7.5,30.277V399.714l202.773,158.33c19.444,16.666,47.221,16.666,69.443,0L482.49,399.714V113.609Z",
    transform: "translate(89.72 12.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M87.832,12.2,26.722,59.421C12.833,70.532,4.5,87.2,4.5,103.865V437.191a55.718,55.718,0,0,0,55.554,55.554H587.821a55.718,55.718,0,0,0,55.554-55.554V103.865c0-16.666-8.333-33.333-22.222-44.444L560.044,12.2",
    transform: "translate(9.389 272.278)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M615.8,59.421,554.688,12.2H82.476L21.366,59.421C13.033,64.977,7.478,73.31,4.7,78.865l280.55,219.44c19.444,16.666,47.221,16.666,69.443,0L635.242,78.865c-5.555-5.555-11.111-13.889-19.444-19.444Z",
    transform: "translate(14.744 272.278)",
    fill: "#dbcbad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M479.712,113.609,368.6,2.5H35.277C18.611,2.5,7.5,13.611,7.5,30.277V399.714l202.773,158.33c19.444,16.666,47.221,16.666,69.443,0L482.49,399.714V113.609Z",
    transform: "translate(89.72 12.539)",
    fill: "#eeebe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M52.021,101.787V29.566c0-5.555,0-11.111,2.778-16.666L18.689,43.455C13.133,49.01,7.578,54.566,4.8,62.9Z",
    transform: "translate(17.422 291.022)",
    fill: "#9d917a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M131.609,113.609H20.5V2.5Z",
    transform: "translate(437.824 12.539)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M370.936,479.758H287.6c-8.333,0-13.889-5.556-13.889-13.889s5.556-13.889,13.889-13.889h83.332c8.333,0,13.889,5.555,13.889,13.889S379.269,479.758,370.936,479.758Z",
    transform: "translate(226.273 215.823)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M332.212,275.447c-13.889,0-30.555-5.555-41.666-13.889L10,39.341C4.441,33.786,1.664,25.452,7.219,19.9s13.889-8.333,19.444-2.778l280.55,219.44c13.889,11.111,36.11,11.111,50,0L637.761,17.119c5.555-5.555,13.889-2.778,19.444,2.778s2.778,13.889-2.778,19.444l-280.55,219.44C362.767,269.892,346.1,275.447,332.212,275.447Z",
    transform: "translate(1.114 322.913)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M493.1,426.991c-8.333,0-13.889-5.555-13.889-13.889V127c0-8.333,5.555-13.889,13.889-13.889s13.889,5.555,13.889,13.889V413.1C506.989,421.436,501.434,426.991,493.1,426.991Zm-472.212,0C12.555,426.991,7,421.436,7,413.1V43.666C7,21.444,26.444,2,48.666,2H381.992c8.333,0,13.889,5.555,13.889,13.889s-5.555,13.889-13.889,13.889H48.666c-8.333,0-13.889,5.555-13.889,13.889V413.1C34.777,421.436,29.222,426.991,20.889,426.991Z",
    transform: "translate(76.332 -0.849)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M601.209,780.871H73.443C34.555,780.871,4,750.316,4,711.428V378.1c0-22.222,8.333-41.666,27.777-55.554l61.11-47.221c5.555-5.555,13.889-2.778,19.444,2.778s2.778,13.889-2.778,19.444l-61.11,47.221q-16.666,12.5-16.666,33.333V711.428c0,22.222,19.444,41.666,41.666,41.666H601.209c22.222,0,41.666-19.444,41.666-41.666V378.1q0-20.833-16.666-33.333L565.1,297.548c-5.555-5.555-8.333-13.889-2.778-19.444s13.889-8.333,19.444-2.778l61.11,47.221c16.666,13.889,27.777,33.333,27.777,55.554V711.428C670.652,750.316,640.1,780.871,601.209,780.871ZM573.432,142H462.323c-8.333,0-13.889-5.555-13.889-13.889V17a15.276,15.276,0,0,1,8.333-13.889c5.555-2.778,11.111,0,13.889,2.778L581.765,117c5.555,5.555,5.555,11.111,5.555,16.666A15.275,15.275,0,0,1,573.432,142Zm-97.22-27.777H540.1L476.212,50.33Z",
    transform: "translate(-4 -1.959)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(7326.134 642.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M1837.385-1488.278c52.282,5.343,105.857,3.734,158.379,4.788,49.9,1.016,101.9,8.522,151.594,4.307,8.67-.739,7.8-13.736-.333-14.863-51.524-7.136-106.43-2.108-158.471-3.808-50.229-1.627-101.235-5.657-151.446-3.217C1829.732-1500.7,1830.3-1489,1837.385-1488.278Z",
    transform: "translate(-1831.734 1501.838)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(0.001 13.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M2133.461-1431.137c-49.823-.019-99.608-1.886-149.394-3.217-23.46-.629-46.9-.943-70.343-1.183-22.3-.24-48.084-3.587-69.955,2.015.925-18.469,1.479-38.435-2.218-55.554-.85-3.993-6.083-3.66-6.914.148-4.567,21.149-2.588,46.55-1.516,68.143.277,5.694,9.724,5.435,10.02-.222.093-1.959.2-3.974.3-5.971,20.41,5.99,43.315,3.956,64.409,4.51,24.9.666,49.785,1.276,74.706,1.534,49.841.5,99.7.462,149.505,2.292C2140.172-1418.345,2141.429-1431.12,2133.461-1431.137Z",
    transform: "translate(-1831.76 1491.931)",
    fill: "#231f1f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M2073.07-1473.47c.2-11.5-17.878-13.237-17.674-1.978.314,17.064-1.96,36.457,3.752,52.744,1.59,4.566,8.763,4.049,10.279-.277C2074.918-1438.566,2072.755-1457.108,2073.07-1473.47Z",
    transform: "translate(-1745.355 1509.099)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M1866.217-1462.844c7.339,0,8.689-11.443,1.294-11.443C1860.172-1474.288,1858.821-1462.844,1866.217-1462.844Z",
    transform: "translate(-1820.336 1512.49)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M1902.309-1457.524c12.664,0,14.993-19.763,2.219-19.763C1891.845-1477.287,1889.516-1457.524,1902.309-1457.524Z",
    transform: "translate(-1807.774 1511.331)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M1947.679-1455.084c15.123,0,17.9-23.59,2.644-23.59C1935.219-1478.674,1932.427-1455.084,1947.679-1455.084Z",
    transform: "translate(-1790.863 1510.794)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M1992.058-1457.408c9.577,0,11.333-14.92,1.682-14.92C1984.182-1472.328,1982.426-1457.408,1992.058-1457.408Z",
    transform: "translate(-1772.255 1513.249)",
    fill: "#231f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M2035.479-1477.1a27.916,27.916,0,0,1-3.9-.554c-3.069-.61-6.544.592-9.077,2.163a13.658,13.658,0,0,0-4.955,5.251,14.083,14.083,0,0,0,2.7,17.119,14.33,14.33,0,0,0,15.659,2.7c5.546-2.514,9.428-9.132,8.208-15.252a24.886,24.886,0,0,1-.536-3.679C2043.391-1473.163,2039.213-1476.879,2035.479-1477.1Z",
    transform: "translate(-1760.601 1511.122)",
    fill: "#231f1f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    transform: "translate(1687.473 2747.862) rotate(-164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M0,95.051c27.71,13.56,55.42,27.71,82.539,41.27,1.769-2.948,10.022-15.329,25.351-19.456,2.358-.59,18.866-4.127,30.657,4.716,5.306,4.127,4.126,7.075,8.254,13.56,8.843,11.791,23.583,14.149,29.478,15.329,44.217,9.433,62.493,50.7,107.889,47.754,1.769,0,33.6-2.948,39.5-19.455s-17.687-39.5-33.015-50.7C250.564,98.588,219.907,116.275,188.66,86.8c-14.15-13.56-8.255-17.1-28.889-41.269C158,43.759,126.756,6.617,102.585.721,73.106-5.764,27.71,31.968,0,95.051ZM86.076,204.709c-9.433,12.97,41.269,55.419,85.487,105.532,2.948,2.948,9.433,10.612,19.455,12.381s13.561-2.948,21.813-2.948c21.814,0,27.119,35.963,50.7,38.322,14.149,1.179,17.687-8.843,31.837-9.433,28.3-1.769,38.91,43.627,57.186,41.269,12.97-1.769,24.172-23.583,22.4-41.269-.589-6.485-2.948-10.612-24.172-37.143-30.067-36.553-34.784-40.09-39.5-42.448-17.1-9.433-21.225-2.358-40.091-13.56-19.455-11.2-21.813-21.814-33.015-21.814-15.329.59-20.634,21.224-31.836,18.866-12.381-2.358-10.023-22.993-28.889-34.784-7.074-4.716-12.38-4.127-31.836-6.485C96.688,205.889,89.613,199.4,86.076,204.709Z",
    transform: "translate(114.422 25.003)",
    fill: "#e1beab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M191.064,46.359C171.019,61.688,135.645,83.5,94.966,78.2c-27.709-3.537-1.216,76.758-80.087,0S195.192-24.979,219.954,26.9",
    transform: "translate(0 0)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M26.034,52.731A80.125,80.125,0,0,1,4.81,22.073C.683,11.461-1.086,6.155.683,2.618c6.485-9.433,43.628,8.254,91.971,27.12C187.574,66.291,202.9,58.626,224.717,83.388c25.941,28.888,11.2,46.575,32.425,96.1,10.613,24.762,51.881,106.711,136.189,126.756,54.829,12.97,128.524-1.179,165.078-50.113,35.373-47.755,26.529-116.144,21.224-159.182-5.306-41.269-17.1-70.747-11.791-73.106,6.485-2.948,30.067,32.426,44.217,67.21,12.97,33.016,37.143,90.793,11.791,151.518-22.4,53.65-70.747,77.233-84.307,84.307C463.488,364.609,389.2,336.31,374.465,331c-63.673-24.172-96.688-71.927-109.069-90.2-12.971-19.456-24.172-51.882-36.553-82.539-7.663-18.866-13.56-34.784-17.1-45.986C149.842,92.821,87.938,72.776,26.034,52.731Z",
    transform: "translate(456.864 307.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M0,18.8C5.307,36.483,16.509,62.424,40.091,80.111c24.172,18.276,40.091,12.381,96.688,30.657,22.993,7.664,52.471,17.1,84.9,37.732a294.11,294.11,0,0,1,54.239,44.807c36.553,1.179,90.793,7.664,148.57,35.374a379.377,379.377,0,0,1,58.957,35.374c.589,20.635,3.537,56.008,21.224,94.33,7.665,15.918,31.247,66.031,87.255,99.046,21.814,12.97,79,46.575,146.211,25.941,7.075-2.358,66.62-21.814,94.33-80.18,18.277-38.322,12.97-72.516,4.717-129.7-7.075-47.754-11.2-75.464-33.015-103.763C767.02,121.97,711.013,112.537,700.4,110.768c-68.979-11.791-129.7,33.016-169.794,61.314-8.255,5.9-14.74,10.612-18.865,14.149C373.784,154.985,288.3,121.969,235.236,96.618,178.049,68.909,111.428,58.886,60.726,21.154c-7.664-5.9-36.552-28.3-51.881-18.866C2.949,5.826.59,13.49,0,18.8Z",
    transform: "translate(210.521 145.475)",
    fill: "#fdbe30",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M163.516,315.417c11.791-2.948,64.262-17.1,99.046-70.158,5.9-9.433,34.784-54.829,25.351-116.144-1.769-13.56-9.433-63.673-51.291-97.278C185.331-9.431,98.665-13.559,43.836,37.144-21.015,96.69,4.926,189.84,6.1,193.967c17.1,56.6,61.314,85.486,74.874,93.74,33.015,21.224,64.852,25.941,82.539,27.709Z",
    transform: "translate(747.511 292.673)",
    fill: "#e8e1dd",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M177.4,9.886c1.77-2.358-24.17-14.149-15.327-8.254,9.433,6.485,14.739,9.433,15.328,8.254Zm-79,127.935c1.179-2.948-29.478-18.866-76.643-48.934-23.582-15.329-31.246-2.358-6.484,11.791C64.792,128.388,97.808,140.18,98.4,137.821ZM236.943,269.883c-1.178-.59-3.537,1.769-7.664,4.717a32.545,32.545,0,0,1-18.866,5.9,57.161,57.161,0,0,1-13.561-1.769,21.783,21.783,0,0,1-6.485-2.948,49.117,49.117,0,0,1-7.075-4.716c-9.433-7.075-17.1-17.687-25.94-30.068-34.2-50.7-65.441-89.614-69.57-86.666s19.457,46.575,53.651,97.278c8.843,12.97,18.866,25.351,31.246,33.605,2.948,2.358,6.485,3.537,10.023,5.306a71.235,71.235,0,0,0,10.613,2.948,50.5,50.5,0,0,0,18.865,0c11.2-2.358,19.456-8.844,22.993-14.15,2.948-5.306,2.948-9.433,1.769-9.433Z",
    transform: "translate(106.818 64.772)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M91.646,75.464C94,74.285,91.056,64.262,82.8,50.7A162.015,162.015,0,0,0,39.174,5.9,39.575,39.575,0,0,0,29.152,1.179,5.314,5.314,0,0,0,26.2.59,7.476,7.476,0,0,0,22.667,0H15.593a16.291,16.291,0,0,0-11.2,7.075,27.57,27.57,0,0,0-2.948,5.9,6.414,6.414,0,0,0-.589,2.948,25.522,25.522,0,0,1-.59,2.948A57.42,57.42,0,0,0,5.57,48.934,54.956,54.956,0,0,0,17.951,64.852c4.126,2.948,6.485,3.537,7.665,2.358,1.769-1.769-4.127-9.433-7.075-22.993a49.76,49.76,0,0,1-.589-22.993V19.456c0-.59.589-.59.589-1.179a2.165,2.165,0,0,1,1.769-.59h1.767c.59,0,.59,0,1.179.59a54.514,54.514,0,0,1,5.9,2.948A336.023,336.023,0,0,1,72.78,58.367c9.432,11.2,16.508,18.276,18.866,17.1Zm56.6,4.716c-1.179,0-2.359,2.358-2.948,7.075s.589,11.2,1.769,18.276c1.769,7.075,4.127,15.918,4.717,23.582s-1.769,17.1-6.485,21.814c-2.359,2.358-4.717,2.948-8.254,3.537a21.733,21.733,0,0,1-10.023-2.948,53.435,53.435,0,0,1-9.432-6.485c-2.948-2.358-5.9-5.306-8.844-7.664a51.483,51.483,0,0,0-15.328-10.612c-4.127-1.769-7.075-1.769-7.665-.59s.589,3.537,2.948,6.485c2.358,3.537,5.895,8.254,9.433,13.56,2.358,2.948,4.717,6.485,7.665,10.022a57.62,57.62,0,0,0,12.38,10.612c4.717,2.948,11.2,5.9,18.866,5.9a28.339,28.339,0,0,0,21.813-8.254,37.088,37.088,0,0,0,10.023-18.866,64.009,64.009,0,0,0,.589-18.277c-1.769-11.791-6.485-19.455-9.433-25.941s-5.895-11.791-7.664-15.329c-1.769-4.127-2.947-5.9-4.126-5.9Z",
    transform: "translate(250.937 226.175)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M144.48,89.821c-1.179-.59-3.538,1.769-4.127,6.485-1.179,4.717-.589,11.791,2.359,18.866,2.358,7.664,7.074,15.329,8.254,22.4.589,3.537,1.179,7.664.589,10.612-.589,3.537-1.769,4.716-3.537,5.9s-5.306,1.179-9.433.59a44.922,44.922,0,0,1-11.791-3.537c-7.074-3.537-13.56-8.254-19.456-12.381-10.612-8.843-18.277-14.739-20.045-12.381-1.769,1.769,1.179,10.023,10.613,22.4,4.717,5.9,11.2,12.97,20.634,18.276a50.852,50.852,0,0,0,16.508,6.485c5.895,1.179,13.56,1.769,21.813-1.769a19.727,19.727,0,0,0,9.433-8.843,28.884,28.884,0,0,0,4.126-11.2c1.179-7.075,0-12.97-1.769-18.866a48.279,48.279,0,0,0-7.074-13.56c-2.359-3.537-4.127-6.485-6.486-9.433-3.537-5.9-5.9-10.023-7.074-13.56s-1.769-5.9-3.537-6.485ZM.037,5.513c0,2.948,6.485,4.127,14.15,8.254a99.212,99.212,0,0,1,26.53,21.224C49.56,45.6,55.456,57.395,60.762,65.649s9.433,13.56,12.381,12.381c2.359-1.179,2.948-7.664.59-17.687A96.663,96.663,0,0,0,56.045,22.611C44.843,9.051,30.1,1.387,18.313.208,5.932-.972-.553,3.155.037,5.514Z",
    transform: "translate(328.396 249.55)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M203.031,195.757c-1.769,5.306,17.687,15.918,34.784,34.784,17.687,18.866,27.12,38.321,32.426,37.142,2.358-.59,3.537-7.075.589-16.508-2.358-9.433-8.843-22.4-18.866-33.605-10.612-11.2-22.4-18.277-31.836-21.224-9.433-3.537-15.918-2.948-17.1-.59Zm54.829-84.307c2.359-1.179-.589-13.56-12.381-30.068a124.119,124.119,0,0,0-24.761-25.351A128.622,128.622,0,0,0,181.808,35.4c-15.328-5.306-30.068-5.9-41.859-7.664-12.38-1.769-21.813-4.716-29.478-8.843C95.142,10.635,91.6-.567,89.247.022c-1.179,0-2.359,3.537-.59,9.433,1.179,5.9,5.9,14.149,14.739,20.635a55.056,55.056,0,0,0,15.328,8.844A165.81,165.81,0,0,0,137,44.829c12.97,2.948,26.53,4.716,38.911,8.843,25.94,8.254,46.575,23.583,59.546,36.553,12.969,12.381,20.045,22.4,22.4,21.224Zm-10.613,8.843c-.589,1.179.59,4.127-.589,6.485-.589,1.179-1.179,3.537-2.948,4.716-1.769,1.769-3.537,2.948-5.306,2.948-3.538,0-8.844-1.769-14.74-5.306s-12.97-8.843-20.634-13.56c-34.784-22.4-65.442-37.142-68.389-32.426s22.993,26.53,57.777,48.934c7.664,4.716,14.149,9.433,22.4,13.56a84.138,84.138,0,0,0,12.97,4.716c4.717,1.179,9.433.59,14.15-.589a19.725,19.725,0,0,0,12.381-11.2c1.769-4.127,2.358-8.843,1.179-11.791a10.161,10.161,0,0,0-4.717-5.9c-2.359-1.768-3.538-1.179-3.538-.589ZM37.365,63.695c-.59,2.358,3.537,6.485,8.843,12.381a53.076,53.076,0,0,1,12.381,26.53c1.179,10.612-1.769,21.224-5.306,28.3s-7.075,11.791-5.307,14.149c1.179,2.358,8.255,1.179,16.509-5.9a46.239,46.239,0,0,0,13.559-38.911A47.366,47.366,0,0,0,55.051,65.463C45.028,60.157,37.954,61.336,37.365,63.695Zm-13.561,0c-1.769-1.768-7.665,0-14.15,7.664A41.369,41.369,0,0,0,1.99,86.688,60.02,60.02,0,0,0,.221,107.323a62.967,62.967,0,0,0,6.485,19.455,40.6,40.6,0,0,0,11.2,12.97c7.664,5.9,14.149,6.485,15.329,4.127s-1.769-6.485-5.306-12.97a101.085,101.085,0,0,1-5.307-11.2c-1.178-4.127-2.948-9.433-3.537-14.739a61.462,61.462,0,0,1,0-14.739,66.01,66.01,0,0,1,2.359-12.381c2.358-7.075,4.126-12.381,2.358-14.15Z",
    transform: "translate(192.022 80.531)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M325.5,129.6c1.769-5.306-71.336-33.016-160.951-68.389S2.416-4.227.059.489,66.679,43.527,156.882,78.9c90.792,35.963,166.846,55.419,168.614,50.7Z",
    transform: "translate(234.043 150.222)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 108.479,
    cy: 9.433,
    rx: 108.479,
    ry: 9.433,
    transform: "translate(532.661 257.836) rotate(18.177)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M204.6,189.049c2.359-4.717-40.679-28.3-97.867-47.755S1.2,113.585.022,118.891s44.217,21.224,100.815,40.68c55.419,18.866,101.4,34.784,103.762,29.478ZM258.25,88.823C259.428,90,268.272,75.853,289.5,57.576c10.612-9.433,24.761-18.866,43.038-27.709,18.277-8.254,40.09-14.739,64.851-15.329A175.642,175.642,0,0,1,475.8,31.046a170.21,170.21,0,0,1,68.978,59.546c18.277,27.12,30.658,60.135,38.911,95.509a409.169,409.169,0,0,1,9.433,54.829c1.769,18.276,1.769,37.142-2.948,54.829-8.253,35.963-33.015,66.031-61.314,85.486-14.739,9.433-30.657,17.1-46.576,21.814a178.667,178.667,0,0,1-49.523,6.485c-32.426,0-63.673-8.254-90.2-20.045a227.545,227.545,0,0,1-67.8-45.4A223.114,223.114,0,0,1,232.9,291.043a195.416,195.416,0,0,1-19.456-47.165c-7.074-27.709-5.9-43.628-7.665-43.628-.589,0-1.178,4.127-1.769,11.791-.589,4.127,0,8.843,0,14.149,0,2.948.59,5.9.59,8.843.589,2.948.589,6.485,1.769,10.023,2.358,14.739,7.665,31.836,17.1,50.7a222.808,222.808,0,0,0,41.858,57.777,257.544,257.544,0,0,0,70.747,50.113c28.3,12.97,61.315,22.4,96.689,22.993A216.429,216.429,0,0,0,487,420.157c18.276-4.716,35.963-12.97,52.471-23.582,15.918-11.2,31.247-24.762,43.628-40.68a197.421,197.421,0,0,0,15.918-26.53c4.127-9.433,8.254-19.456,10.613-29.478,5.306-20.635,4.717-41.269,2.948-61.314a362.268,362.268,0,0,0-10.023-57.187c-8.843-36.553-21.813-71.927-42.448-101.4a180.977,180.977,0,0,0-34.784-38.322,182.874,182.874,0,0,0-41.859-25.941A180.749,180.749,0,0,0,397.976.389,169.436,169.436,0,0,0,329,19.844,181.66,181.66,0,0,0,285.37,51.68c-10.613,10.612-17.1,19.455-21.225,26.53-4.717,6.485-6.485,10.612-5.895,10.612Z",
    transform: "translate(481.107 238.167)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M273.557,128.236c.589,0,.589-5.306-1.769-14.149a154.273,154.273,0,0,0-13.561-35.374c-7.664-14.15-18.275-30.657-34.784-44.807S185.712,7.965,160.95,3.249C136.188-2.057,112.016-.289,91.382,4.428A173.918,173.918,0,0,0,38.91,25.063,161.42,161.42,0,0,0,8.843,48.645C2.358,55.13,0,59.257,0,59.846c.589.59,4.126-2.948,11.2-8.254s17.1-12.97,30.656-20.045A191.657,191.657,0,0,1,93.15,13.271c20.045-4.127,43.038-5.306,65.441-.59a137.566,137.566,0,0,1,58.956,28.3A145.735,145.735,0,0,1,252.332,82.25c8.254,13.56,12.38,25.351,15.918,33.605,3.537,7.664,4.716,12.381,5.306,12.381Z",
    transform: "translate(761.17 284.831)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M304.948,26.6c-.589,0,2.359,7.075,5.306,20.635a198.348,198.348,0,0,1,6.485,56.6c-.589,23.582-6.485,52.471-24.171,79a157.168,157.168,0,0,1-32.426,36.553,124.252,124.252,0,0,1-46.576,23.582c-17.686,4.127-35.373,3.537-51.881.59-17.1-2.948-33.6-6.485-48.344-11.791a175.027,175.027,0,0,1-69.568-45.986,182.874,182.874,0,0,1-31.836-47.165c-5.9-12.381-8.255-19.456-8.844-19.456S3.681,126.829,8.4,139.8a158.96,158.96,0,0,0,30.068,50.113A169.175,169.175,0,0,0,109.8,239.436c15.329,5.9,32.426,9.433,50.113,12.381s37.143,4.127,56.008-.589a126.1,126.1,0,0,0,50.113-25.351,174.359,174.359,0,0,0,34.194-38.911c8.255-14.149,15.329-28.889,18.277-43.038a169.277,169.277,0,0,0,4.717-40.68c-.589-24.762-5.306-44.807-10.022-57.777-3.538-12.381-7.665-18.866-8.255-18.866ZM27.855.074c-1.179-.59-4.717,2.358-10.023,8.843a97.429,97.429,0,0,0-13.559,28.3C.734,49.007-.445,60.209.145,68.463s1.769,12.97,2.948,12.97c2.948,0,3.537-19.456,10.613-41.269C20.19,18.35,30.213,1.842,27.855.074Z",
    transform: "translate(722.705 367.596)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 22.993,
    cy: 9.433,
    rx: 22.993,
    ry: 9.433,
    transform: "translate(42.376 51.947) rotate(35.095)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 30.068,
    cy: 9.433,
    rx: 30.068,
    ry: 9.433,
    transform: "translate(69.845 15.109) rotate(37.426)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 46.576,
    cy: 9.433,
    rx: 46.576,
    ry: 9.433,
    transform: "matrix(-0.795, 0.607, -0.607, -0.795, 342.742, 529.367)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 9.433,
    cy: 40.68,
    rx: 9.433,
    ry: 40.68,
    transform: "translate(352.016 562.226)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 850.602, 510.993)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.705,
    cy: 7.19,
    rx: 75.705,
    ry: 7.19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.705,
    cy: 7.19,
    rx: 77.705,
    ry: 9.19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    transform: "translate(952.568 491.96) rotate(-149)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.706,
    cy: 7.193,
    rx: 75.706,
    ry: 7.193,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.706,
    cy: 7.193,
    rx: 77.706,
    ry: 9.193,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInPilot);
export default __webpack_public_path__ + "static/media/notInPilot.3b4b550d1219f00920210227de729463.svg";
export { ForwardRef as ReactComponent };